@for (item of orderHistoryService.excludedItems; track item) {
  <div>
    <span class="alert-icon"><cx-icon class="cx-icon fas fa-exclamation-circle"></cx-icon></span>
    <p>{{ orderHistoryService.getReasonToExclude(item) }}</p>
  </div>
}
